module.exports = __webpack_public_path__ + "img/title-dver-2-t.ba89fdf9.png";